import './style.scss';

const IconPlugin = `<svg width="16px" height="16px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M4.7433 5.33104C4.37384 4.92053 3.74155 4.88726 3.33104 5.25671C2.92053 5.62617 2.88726 6.25846 3.25671 6.66897L7.15465 11L3.25671 15.331C2.88726 15.7416 2.92053 16.3738 3.33104 16.7433C3.74155 17.1128 4.37384 17.0795 4.7433 16.669L8.50001 12.4949L12.2567 16.669C12.6262 17.0795 13.2585 17.1128 13.669 16.7433C14.0795 16.3738 14.1128 15.7416 13.7433 15.331L9.84537 11L13.7433 6.66897C14.1128 6.25846 14.0795 5.62617 13.669 5.25671C13.2585 4.88726 12.6262 4.92053 12.2567 5.33104L8.50001 9.50516L4.7433 5.33104ZM17.3181 14.0484C17.6174 13.7595 18.1021 13.7977 18.3524 14.13C18.5536 14.3971 18.5353 14.7698 18.3088 15.0158L15.2643 18.3227C14.9955 18.6147 14.9248 19.0382 15.0842 19.4017C15.2437 19.7652 15.6031 20 16 20H20C20.5523 20 21 19.5523 21 19C21 18.4477 20.5523 18 20 18H18.2799L19.7802 16.3704C20.6607 15.414 20.7321 13.965 19.95 12.9267C18.9769 11.6348 17.0925 11.4862 15.929 12.6096L15.3054 13.2116C14.9081 13.5953 14.897 14.2283 15.2806 14.6256C15.6642 15.023 16.2973 15.0341 16.6946 14.6505L17.3181 14.0484Z"/>
</svg>`;

export class SubScriptsPlugin {
	api: any;
	tag: string;
	button: HTMLButtonElement;
	_state: boolean;
	iconClasses: any;

	get state() {
		return this._state;
	}

	set state(state) {
		this._state = state;
	}

	constructor({ api }: any) {
		this.api = api;
		this.tag = 'SUB';
		this._state = false;
		this.button = document.createElement('button');
		this.iconClasses = {
			base: this.api.styles.inlineToolButton,
			active: this.api.styles.inlineToolButtonActive,
		};
	}

	static get isInline() {
		return true;
	}

	render() {
		this.button = document.createElement('button');
		this.button.type = 'button';
		this.button.innerHTML = this.toolboxIcon;
		return this.button;
	}

	get toolboxIcon() {
		return IconPlugin;
	}

	surround(range: any) {
		if (this.state) {
			this.unwrap(range);
			return;
		}

		this.wrap(range);
	}

	wrap(range: any) {
		const selectedText = range.extractContents();
		const sub = document.createElement(this.tag);

		sub.appendChild(selectedText);
		range.insertNode(sub);

		this.api.selection.expandToTag(sub);
	}

	unwrap(range: any) {
		const sub = this.api.selection.findParentTag(this.tag);
		const text = range.extractContents();

		sub.remove();

		range.insertNode(text);
	}

	checkState() {
		const sub = this.api.selection.findParentTag(this.tag);
		this.button.classList.toggle(this.iconClasses.active, !!sub);
		this.state = !!sub;
	}

	static get sanitize() {
		return {
			sub: {},
		};
	}
}
